import { useEffect, useState } from 'react';
import { getCustomizedNavTitle } from 'lib/helpers';
import { useReduxState } from '.';

import type { NavSection } from 'lib/helpers/getCustomizedNavTitle';

interface Params {
  fallbackUrl?: string;
}

const usePreviousPage = ({ fallbackUrl = '/' }: Params) => {
  const { language, messages, serverConfig } = useReduxState();

  const [backLink, setBackLink] = useState(fallbackUrl);
  const [backLinkTitle, setBackLinkTitle] = useState('');

  const getNavTitle = (section: NavSection, defaultTitle: string) => {
    return getCustomizedNavTitle({
      defaultTitle,
      language,
      navLinksCustomTexts: serverConfig.navLinksCustomTexts,
      section
    });
  };

  useEffect(() => {
    if (typeof window !== 'undefined' && sessionStorage) {
      const previousPath = sessionStorage.getItem('vuoPreviousPath');
      let newLink = fallbackUrl;
      if (previousPath) {
        const previousPathParts = previousPath.split(':');
        const subroot = previousPathParts[0];
        if (
          window.location.pathname.startsWith(subroot) &&
          previousPathParts[1] !== window.location.pathname
        ) {
          newLink = previousPathParts[1];
        }
      }
      setBackLink(newLink);

      let newTitle = messages.commonGoBack;
      if (newLink === '/') {
        newTitle = getNavTitle('home', messages.headerHome);
      } else if (/^\/achievements/.test(newLink)) {
        newTitle = getNavTitle('achievements', messages.commonAchievementsAlt);
      } else if (/^\/calendar/.test(newLink)) {
        newTitle = getNavTitle('calendar', messages.eventCalendar);
      } else if (/^\/courses/.test(newLink)) {
        newTitle = getNavTitle('courses', messages.headerCourses);
      } else if (/^\/groups/.test(newLink)) {
        newTitle = getNavTitle('groups', messages.commonGroups);
      } else if (/^\/my-team/.test(newLink)) {
        newTitle = getNavTitle('myteam', messages.myTeamPage);
      } else if (/^\/paths/.test(newLink)) {
        newTitle = getNavTitle('paths', messages.paths);
      } else if (/^\/profile/.test(newLink)) {
        newTitle = getNavTitle('profile', messages.headerProfile);
      } else if (/^\/users/.test(newLink)) {
        newTitle = getNavTitle('users', messages.commonUsers);
      }

      setBackLinkTitle(newTitle);
    }
  }, []);

  return { as: backLink, href: backLink, title: backLinkTitle };
};

export default usePreviousPage;
